module.exports = __webpack_public_path__ + "img/1558551131.dbac82b9.jpg";